import * as cn from 'classnames'
export const omit = (obj: any, blacklist: string[]): any => {
  const insensitiveBlacklist = blacklist.map(prop => prop.toLowerCase())
  return Object.keys(obj).reduce((result: any, prop: string) => {
    if (!insensitiveBlacklist.includes(prop.toLowerCase())) {
      result[prop] = obj[prop]
    }
    return result
  }, {})
}
type ClassValue =
  | string
  | number
  | ClassDictionary
  | ClassArray
  | undefined
  | null
  | false
interface ClassArray extends Array<ClassValue> { }
interface ClassDictionary { [id: string]: boolean | undefined | null }
interface BaseComponentProps { className?: string }
export const extractClassNamesFromProps = (props: BaseComponentProps, ...extraClasses: ClassValue[]): string =>
  cn(...extraClasses, { ...(props.className && { [props.className]: true }) })
